export default __webpack_public_path__ + "static/media/category_33.bac4c68f.png";